<div class="landing-categories-card">
  <i class="icon landing-categories-card__icon" [class]="category.iconClass"></i>
  <p class="landing-categories-card__name body1--medium">{{ category.name | translate }}</p>
</div>
